import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_button = _resolveComponent("base-button")

  return (_openBlock(), _createBlock(_component_base_button, _mergeProps(_ctx.$attrs, {
    class: [$options.visibilityClass],
    width: "wide",
    shape: "soft",
    onClick: $options.onClick,
    "data-qa": "create-account-button:login"
  }), {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.Resources.Account.LogInButton), 1 /* TEXT */)
    ]),
    _: 1 /* STABLE */
  }, 16 /* FULL_PROPS */, ["class", "onClick"]))
}